import React from 'react';

const workCards = [
  {
    type: 'Curatorial',
    title: 'Echoes of the Indus',
    sub: 'Film & culture collective curating programs on climate, identity, and solidarity in the South Asian diaspora. Raised $5K+ through cultural programming.',
    date: 'Toronto, 2024–25',
  },
  {
    type: 'Film & Organising',
    title: 'Cine Móvil NYC',
    sub: 'Mobile cinema initiative using documentary film for social organising. $10K secured in public sector funding.',
    date: 'New York, 2023–24',
  },
  {
    type: 'Communications',
    title: 'PEN America',
    sub: 'Digital Communications Manager reaching 40K+ audiences internationally; advocacy for freedom of expression.',
    date: 'New York, 2022–24',
  },
  {
    type: 'Research & Film',
    title: 'Tharparkar Documentary',
    sub: 'Directed & filmed ethnographic documentary on indigenous communities for Karachi Urban Lab.',
    date: 'Pakistan, 2019–20',
  },
  {
    type: 'Journalism',
    title: 'Herald Magazine',
    sub: 'In-depth reporting on GBV, harm reduction, religious minorities, and the 2018 General Elections.',
    date: 'Pakistan, 2018–20',
  },
  {
    type: 'Archive & Digital',
    title: 'SAADA',
    sub: 'Digital media campaign translating archival material into visual-first narratives on South Asian histories.',
    date: 'New York, 2022',
  },
];

const WorkGrid = () => (
  <section id="work" className="bg-bg-primary px-10 py-10" style={{ borderBottom: '0.5px solid #e0ddd8' }}>
    <span className="section-label">Selected Work</span>
    <div
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
      style={{ marginTop: '1.5rem' }}
    >
      {workCards.map((card, i) => (
        <div
          key={i}
          className="p-5 hover:bg-bg-secondary transition-colors duration-200"
          style={{ border: '0.5px solid #e0ddd8', margin: '-0.25px' }}
        >
          <p
            className="text-terracotta font-inter mb-3"
            style={{ fontSize: '10px', letterSpacing: '0.15em', textTransform: 'uppercase' }}
          >
            {card.type}
          </p>
          <p className="font-playfair text-ink mb-2" style={{ fontSize: '15px', lineHeight: 1.4 }}>
            {card.title}
          </p>
          <p className="text-muted" style={{ fontSize: '12px', lineHeight: 1.5 }}>
            {card.sub}
          </p>
          <p className="text-muted mt-3 font-inter" style={{ fontSize: '11px', letterSpacing: '0.05em' }}>
            {card.date}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default WorkGrid;
